import React from "react";
import { LabelField } from ".";
export const MyCheckbox = ({
  title,
  checked,
  name,
  handlechange,
  disabled = false,
  ...props
}) => {
  return (
    <div className="d-flex" style={{ alignItems: "baseline", opacity: disabled ? 0.4 : 1 }}>
      <label className={`checkbox checkbox-lg checkbox-single mr-4${disabled ? " checkbox-disabled" : ""}`} style={props.style}>
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={handlechange}
          disabled={disabled}
        />
        <span />
      </label>
      <span>
        <LabelField title={title} />
      </span>
    </div>
  );
};
